import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/icon.css';
import './assets/css/main.css';
import './assets/icon/iconfont.css';
import filters from './filters';
import store from './store/index';

Vue.config.productionTip = false;
Vue.use(ElementUI, { size: 'small' });

// 过滤器遍历
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));

window.vm = new Vue({
  router,
  store,
  filters: filters,
  render: h => h(App)
}).$mount('#app');
